import { Component } from "@angular/core";
import { NullableRegisteredUserDetails } from "@models/user.model";
import { UserService } from "../../services/user/user.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
    selector: "app-profile-details",
    templateUrl: "./profile-details.component.html",
    styleUrl: "./profile-details.component.scss",
    standalone: false,
})
export class ProfileDetailComponent {
    public userDetails!: NullableRegisteredUserDetails;

    constructor(
        private userService: UserService,
        private router: Router,
        private location: Location,
    ) {}

    ngOnInit(): void {
        this.getUserDetails();
    }

    private getUserDetails(): void {
        this.userService.getUserDetails().subscribe((response) => {
            this.userDetails = response;
        });
    }

    public goBack(): void {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            // No previous page — means open from notification
            this.router.navigate(["/home"]);
        }
    }

    public clickeditProfileDetails(id: number): void {
        this.router.navigate([`/account/profileDetails/${id}`]);
    }
}
